import { motion } from "framer-motion";
import { UtensilsCrossed, Activity, Brain, Sprout, ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { RESOURCE_CATEGORIES } from "@/data/content";
import { waLink, GENERAL_MESSAGE } from "@/config";

const ICONS = { UtensilsCrossed, Activity, Brain, Sprout };

export default function Resources() {
  return (
    <section id="resources" className="py-24 sm:py-32 bg-cardbg" data-testid="resources-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Education & Resources"
          title="Learn. Understand. Transform."
          sub="Articles, videos, guides, workshops, meditation resources and recipes — a growing library across four pillars of health."
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {RESOURCE_CATEGORIES.map((r, i) => {
            const Icon = ICONS[r.icon];
            return (
              <Reveal key={r.title} delay={i * 0.07}>
                <motion.div
                  whileHover={{ y: -8 }}
                  transition={{ duration: 0.35 }}
                  className="h-full bg-ivory border border-botanical/10 rounded-3xl p-8 shadow-card hover:shadow-hover transition-shadow duration-300"
                  data-testid={`resource-card-${i}`}
                >
                  <div className="w-12 h-12 rounded-2xl bg-forest flex items-center justify-center mb-5">
                    <Icon size={22} className="text-gold" />
                  </div>
                  <h3 className="font-serif text-2xl text-forest">{r.title}</h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-inkmuted">{r.text}</p>
                  <p className="mt-5 text-[11px] font-bold uppercase tracking-[0.18em] text-gold">
                    New resources coming soon
                  </p>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={0.2} className="text-center mt-12">
          <motion.a
            whileHover={{ scale: 1.04, y: -2 }}
            whileTap={{ scale: 0.97 }}
            href={waLink(GENERAL_MESSAGE)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="resources-explore-button"
            className="inline-flex items-center gap-2 rounded-full border border-forest/25 text-forest px-7 py-3.5 text-sm font-bold tracking-wide hover:border-forest hover:bg-forest/5 transition-colors"
          >
            EXPLORE FREE RESOURCES <ArrowRight size={15} />
          </motion.a>
        </Reveal>
      </div>
    </section>
  );
}
